<template>
  <div class="logo">
    <button class="logo-text" @click="$emit('clikedLogo')">
      <img src="@/assets/images/logo_lower.svg" alt="VOICES From You" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'PartLogo'
}
</script>

<style lang="scss" scoped>
.logo {
  box-sizing: content-box;
  width: 100/375 * 100%;
  padding: 40/750 * 100% 0 0 40/750 * 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 101;
  @include media() {
    width: 140px;
    padding: 40px 0 0 40px;
  }
  &-text {
    @include media() {
      cursor: pointer;
      transition: opacity .3s ease;
      &:hover {
        opacity: .6;
      }
    }
  }
}
</style>
